module.exports = __webpack_public_path__ + "static/media/building.ed5bcf58.svg";